/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizeravatar1Inputs */

const en_organizeravatar1 = /** @type {(inputs: Organizeravatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change picture`)
};

const de_organizeravatar1 = /** @type {(inputs: Organizeravatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilbild ändern`)
};

/**
* | output |
* | --- |
* | "Change picture" |
*
* @param {Organizeravatar1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizeravatar1 = /** @type {((inputs?: Organizeravatar1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizeravatar1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizeravatar1(inputs)
	return de_organizeravatar1(inputs)
});
export { organizeravatar1 as "organizerAvatar" }